import { MethodMap } from "@/types";

/**
 * Handles execution of registered callbacks after ajax request
 */
export class CallbackService {
  /**
   * Execute method, if exists
   * @param name Method to execute
   * @param args Arguments for method
   */
  public static call(name: string, args: object = {}) {
    if (name) {
      if (CallbackService.methodMap[name]) {
        CallbackService.methodMap[name](args);
      } else {
        console.error('Callback "' + name + "\" doesn't exist");
      }
    }
  }

  /**
   * Map of callbacks, {{name}}: {{method}}
   */
  private static methodMap: MethodMap = {
    exampleCallback: CallbackService.exampleCallback,
    callbackBluemedia: CallbackService.callbackPayment,
    callbackTrustly: CallbackService.callbackPayment,
    callbackSafecharge: CallbackService.callbackPayment,
  };

  private static exampleCallback() {
    console.info("executed exampleCallback");
  }

  /**
   * Handles callback after user makes payment request
   * @param args
   */
  private static callbackPayment(args: CallbackPaymentInterface) {
    let url = args.Url;

    if (args.Query) {
      url += "?" + args.Query;
    }

    window.location.href = url;
  }
}

interface CallbackPaymentInterface {
  Url: string;
  Query?: string;
}
